import { useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { toast } from "sonner";
import InstallPWA from "@/components/InstallPWA";
import { ShieldCheck, ArrowRight, GraduationCap } from "lucide-react";

export default function ParentAccess() {
  const [step, setStep] = useState(1);
  const [roll, setRoll] = useState("");
  const [mobile, setMobile] = useState("");
  const [code, setCode] = useState("");
  const [busy, setBusy] = useState(false);

  const request = async (e) => {
    e.preventDefault(); setBusy(true);
    try {
      await api.post("/parent/request-code", { student_roll: roll, parent_mobile: mobile });
      toast.success("Code sent via SMS (mocked)");
      setStep(2);
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Failed");
    }
    setBusy(false);
  };

  const verify = async (e) => {
    e.preventDefault(); setBusy(true);
    try {
      const r = await api.post("/parent/verify-code", { student_roll: roll, code }, { responseType: "blob" });
      window.open(URL.createObjectURL(r.data), "_blank");
      toast.success("Marks card opened");
    } catch (err) {
      toast.error("Invalid or expired code");
    }
    setBusy(false);
  };

  return (
    <div className="min-h-screen bg-[#FBF9F6]">
      <nav className="border-b-2 border-black bg-white">
        <div className="max-w-7xl mx-auto px-6 py-4 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-2 min-w-0">
            <div className="w-9 h-9 shrink-0 bg-[#C4B5FD] border-2 border-black rounded-lg grid place-items-center shadow-[2px_2px_0_0_#000]">
              <GraduationCap size={20} strokeWidth={2.5}/>
            </div>
            <span className="display text-base sm:text-xl font-bold truncate">Ponderr Schoolz</span>
          </Link>
          <div className="flex items-center gap-2 shrink-0">
            <div className="hidden sm:block"><InstallPWA/></div>
            <Link to="/login" className="nb-btn nb-btn-ghost text-xs sm:text-sm">Staff Sign In</Link>
          </div>
        </div>
      </nav>
      <div className="max-w-md mx-auto p-6 mt-10">
        <div className="nb-card p-8">
          <div className="flex items-center gap-2 mb-2"><ShieldCheck size={24}/>
            <h1 className="display text-2xl font-bold">Parent Portal</h1></div>
          <p className="text-sm text-slate-600 mb-5">
            Secure OTP-based access to your child's marks card.
          </p>

          {step===1 && (
            <form onSubmit={request} className="space-y-3">
              <div><label className="nb-label">Student Roll No</label>
                <input data-testid="parent-roll" required value={roll} onChange={e=>setRoll(e.target.value)} className="nb-input mt-1" placeholder="e.g. 10A01"/></div>
              <div><label className="nb-label">Your Mobile (as registered)</label>
                <input data-testid="parent-mobile" required value={mobile} onChange={e=>setMobile(e.target.value)} className="nb-input mt-1" placeholder="+91..."/></div>
              <button data-testid="parent-send-code" disabled={busy} className="nb-btn w-full justify-center">
                {busy ? "Sending..." : "Send Code"} <ArrowRight size={16}/>
              </button>
              <div className="text-xs text-slate-500 mt-2 nb-card-sm p-2 bg-[#FDE047]">
                Demo: roll <code>10A01</code> · mobile <code>+919999111101</code>. Code visible in Admin → Notifications.
              </div>
            </form>
          )}

          {step===2 && (
            <form onSubmit={verify} className="space-y-3">
              <div><label className="nb-label">6-digit Code</label>
                <input data-testid="parent-code" required value={code} onChange={e=>setCode(e.target.value)} className="nb-input mt-1 mono tracking-widest text-center text-xl" maxLength={6} placeholder="000000"/></div>
              <button data-testid="parent-verify" disabled={busy} className="nb-btn w-full justify-center">
                {busy ? "Verifying..." : "Open Marks Card"} <ArrowRight size={16}/>
              </button>
              <button type="button" onClick={()=>setStep(1)} className="nb-btn nb-btn-ghost w-full justify-center">Back</button>
            </form>
          )}
        </div>
      </div>
    </div>
  );
}
